
/**
 * 轮播图相关API服务
 */
export const bannerService = {
  /**
   * 获取轮播图列表
   * @returns {Promise<Array>} 轮播图数据数组
   */
  getBanners: (params = {}) => {
    // return []
    // return [
    //     { url: 'images/banner1.jpg', linkType: 'business', targetId: 1, category: 'homestay' },
    //     { url: 'images/banner2.jpg', linkType: 'specialty', targetId: '', category: '' },
    //     { url: 'images/banner3.jpg', linkType: 'business', targetId: 10, category: 'food' }
    //   ];?${params.toString()}
    return fetch(`/qhkj-agri-map-api/base/banner/canShowList`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
  }
};